const {produce} = require("immer");
const { setLocalItem, getLocalItem } = require("../browserStorage");

const defaultLanguage = () => {
  let lang = getLocalItem("lang");
  if(!lang) {
    if(global.navigator) {
      lang = global.navigator.language;
    } else {
      let env = process.env
      lang = env.LC_ALL || env.LC_MESSAGES || env.LANG || env.LANGUAGE;
    }
    if(!lang) lang = "en";
    else if(lang.includes('-')) lang = lang.split("-")[0];
  }
  return lang;
}

const initialState = {
  lang: defaultLanguage(),
  initTheme: {},
  navmenu: {
    open: true,
    variant: 'permanent'
  }
};

module.exports = function(state = initialState, action) {
  switch (action.type) {

    case "SET_INFO":
      return produce(state, draft => {
        Object.assign(draft.initTheme, action.theme)
      });

    case 'SET_LANGUAGE':
      if(action.language) {
        setLocalItem("lang", action.language);
        return produce(state, draft => {
          draft.lang = action.language;
        });
      } else return state

    case "OPEN_NAVMENU":
      return produce(state, draft => {
        draft.navmenu.open = action.open;
      });

    case "NAVMENU_VARIANT":
      return produce(state, draft => {
        draft.navmenu.variant = action.variant;
      });

    default:
      return state;
  }
}
